/** @format */

import React from "react";
import styles from "./Packages.module.scss";
import cn from "classnames";
import man from "../../../../img/man.svg";
import { useTranslation } from "react-i18next";
const Packages = () => {
  const { t } = useTranslation();
  return (
    <section
      className={cn(
        styles.packages,
        localStorage.getItem("i18n") === "EN" ? styles.packages__en : ""
      )}
    >
      <div className="container">
        <h2 className={styles.mobile}>{t("The crop yields")}</h2>
        <h2 className={styles.desktop}>
          {t("Harvest yields per planting site NFT")}
        </h2>
        <p className={styles.packages__desc}>
          {t("Secure access to your future planting site NFT now")}
        </p>
        <div className={styles.packages__first}>
          <div className={styles.packages__first_left}>
            <div className={styles.packages__first_left__img}>
              <svg
                width="54"
                height="59"
                viewBox="0 0 54 59"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M53.1365 33.211L46.4851 31.2362C44.7856 30.7316 43.0405 30.4155 41.2777 30.2918C43.405 26.931 44.8757 23.1607 45.573 19.2428L46.7898 12.4116L40.4885 15.3163C38.0522 16.4393 35.7953 17.8617 33.7612 19.5455C33.2873 15.0978 31.9778 10.7432 29.9053 6.7751L26.6932 0.625L23.4811 6.77596C21.6483 10.2863 20.4189 14.0499 19.8271 17.9621C19.7474 18.4887 19.6797 19.0162 19.6236 19.5441C17.5898 17.8612 15.3341 16.4396 12.8983 15.3161L6.59701 12.4114L7.81387 19.2426C8.51161 23.1607 9.98231 26.9314 12.1091 30.2916C10.346 30.4149 8.60129 30.7318 6.90173 31.236L0.25 33.2108L5.67116 37.541C8.4148 39.7326 11.6082 41.2939 14.9914 42.1329C14.8435 42.4024 14.7044 42.6728 14.5769 42.9423L11.6131 49.2166L18.4555 48.0632C20.7635 47.6741 22.9759 46.7587 24.8856 45.4069L24.8852 58.375H28.5084V45.4122C30.4164 46.7612 32.6255 47.6748 34.9297 48.0628L41.7725 49.2162L38.8088 42.9419C38.6817 42.6724 38.5422 42.4016 38.3943 42.1324C41.7771 41.2935 44.9701 39.7323 47.7145 37.5406L53.1365 33.211ZM32.5706 39.2232C31.8766 39.2232 34.4441 42.1824 35.5343 44.4899C33.6022 44.1639 31.8109 43.3764 30.293 42.2277C29.052 41.2878 27.995 40.1071 27.193 38.7391C27.0921 38.5671 26.9077 38.4612 26.7088 38.4579H26.6988H26.6897C26.4874 38.4579 26.2988 38.5646 26.1963 38.7395C25.3939 40.1075 24.3373 41.2891 23.0963 42.2281C21.5784 43.3769 19.7875 44.1648 17.855 44.4903C18.9452 42.1824 21.5122 39.2237 20.8183 39.2237C16.1928 39.2237 11.638 37.6687 7.93413 34.7108C9.86495 34.1373 11.8436 33.8565 13.8093 33.8565C16.0532 33.8565 18.2807 34.2224 20.4025 34.9372C20.4275 34.9455 20.452 34.9492 20.4752 34.9492C20.658 34.9492 20.7672 34.7075 20.6069 34.5725C19.1238 33.3257 17.7831 31.9256 16.6048 30.4006C13.9766 26.9966 12.1584 22.9659 11.3817 18.6074C16.3307 20.8887 20.4 24.5714 23.159 29.098C23.2031 29.1694 23.2704 29.201 23.3376 29.201C23.4581 29.201 23.5769 29.0996 23.5499 28.9505C22.316 22.0462 23.3642 14.8299 26.6938 8.45266C29.1235 13.1047 30.3382 18.2049 30.3382 23.3048C30.3382 25.1942 30.1713 27.083 29.8378 28.9499C29.8112 29.099 29.9295 29.2003 30.05 29.2003C30.1173 29.2003 30.1845 29.1692 30.2282 29.0973C32.9875 24.5703 37.0569 20.8881 42.0055 18.6067C41.2292 22.9651 39.4114 26.9958 36.7824 30.4C35.6041 31.9251 34.2635 33.3251 32.7803 34.5719C32.62 34.7064 32.7292 34.9486 32.912 34.9486C32.9352 34.9486 32.9593 34.9444 32.9847 34.9365C35.1065 34.2222 37.3343 33.8559 39.5783 33.8559C41.544 33.8559 43.5223 34.1366 45.4535 34.7102C41.7505 37.6676 37.1952 39.2226 32.5704 39.2226L32.5706 39.2232Z"
                  fill="white"
                />
              </svg>

            </div>
            <div className={styles.packages__first_left__text}>
              <p style={{ marginLeft: "-3px" }}>{t("Planting site")}</p>
              <p style={{ marginLeft: "-1px" }}>NFT</p>
            </div>
            <div className={styles.packages__first_left__text_mobile}>
              <p style={{ marginLeft: "-3px" }}>
                {t("Harvest yield per planting site NFT")}
              </p>
            </div>
          </div>
          <div className={styles.packages__first_right}>
            <div>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24 26.6668V13.3335"
                  stroke="#509C5B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 26.6668V5.3335"
                  stroke="#509C5B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 26.6665V18.6665"
                  stroke="#509C5B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <p>{t("One planting site is harvested 4 times a year")}</p>
            </div>
            <div>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.3333 5.3335H6.66667C5.19391 5.3335 4 6.5274 4 8.00016V26.6668C4 28.1396 5.19391 29.3335 6.66667 29.3335H25.3333C26.8061 29.3335 28 28.1396 28 26.6668V8.00016C28 6.5274 26.8061 5.3335 25.3333 5.3335Z"
                  stroke="#509C5B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M21.3333 2.6665V7.99984"
                  stroke="#509C5B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10.6667 2.6665V7.99984"
                  stroke="#509C5B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4 13.3335H28"
                  stroke="#509C5B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22.6667 18.6665H14.6667"
                  stroke="#509C5B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17.3333 24H9.33325"
                  stroke="#509C5B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.33325 18.6665H9.34659"
                  stroke="#509C5B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22.6667 24H22.6801"
                  stroke="#509C5B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p>{t("Harvest yields are credited to the account")}</p>
            </div>
          </div>
        </div>
        <div className={styles.packages__second}>
          <div className={styles.packages__second_left}>
            <img src={man} alt={t("man")} />
            <div>
              <div>
                <div>
                  <svg
                    width="54"
                    height="59"
                    viewBox="0 0 54 59"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M53.1365 33.211L46.4851 31.2362C44.7856 30.7316 43.0405 30.4155 41.2777 30.2918C43.405 26.931 44.8757 23.1607 45.573 19.2428L46.7898 12.4116L40.4885 15.3163C38.0522 16.4393 35.7953 17.8617 33.7612 19.5455C33.2873 15.0978 31.9778 10.7432 29.9053 6.7751L26.6932 0.625L23.4811 6.77596C21.6483 10.2863 20.4189 14.0499 19.8271 17.9621C19.7474 18.4887 19.6797 19.0162 19.6236 19.5441C17.5898 17.8612 15.3341 16.4396 12.8983 15.3161L6.59701 12.4114L7.81387 19.2426C8.51161 23.1607 9.98231 26.9314 12.1091 30.2916C10.346 30.4149 8.60129 30.7318 6.90173 31.236L0.25 33.2108L5.67116 37.541C8.4148 39.7326 11.6082 41.2939 14.9914 42.1329C14.8435 42.4024 14.7044 42.6728 14.5769 42.9423L11.6131 49.2166L18.4555 48.0632C20.7635 47.6741 22.9759 46.7587 24.8856 45.4069L24.8852 58.375H28.5084V45.4122C30.4164 46.7612 32.6255 47.6748 34.9297 48.0628L41.7725 49.2162L38.8088 42.9419C38.6817 42.6724 38.5422 42.4016 38.3943 42.1324C41.7771 41.2935 44.9701 39.7323 47.7145 37.5406L53.1365 33.211ZM32.5706 39.2232C31.8766 39.2232 34.4441 42.1824 35.5343 44.4899C33.6022 44.1639 31.8109 43.3764 30.293 42.2277C29.052 41.2878 27.995 40.1071 27.193 38.7391C27.0921 38.5671 26.9077 38.4612 26.7088 38.4579H26.6988H26.6897C26.4874 38.4579 26.2988 38.5646 26.1963 38.7395C25.3939 40.1075 24.3373 41.2891 23.0963 42.2281C21.5784 43.3769 19.7875 44.1648 17.855 44.4903C18.9452 42.1824 21.5122 39.2237 20.8183 39.2237C16.1928 39.2237 11.638 37.6687 7.93413 34.7108C9.86495 34.1373 11.8436 33.8565 13.8093 33.8565C16.0532 33.8565 18.2807 34.2224 20.4025 34.9372C20.4275 34.9455 20.452 34.9492 20.4752 34.9492C20.658 34.9492 20.7672 34.7075 20.6069 34.5725C19.1238 33.3257 17.7831 31.9256 16.6048 30.4006C13.9766 26.9966 12.1584 22.9659 11.3817 18.6074C16.3307 20.8887 20.4 24.5714 23.159 29.098C23.2031 29.1694 23.2704 29.201 23.3376 29.201C23.4581 29.201 23.5769 29.0996 23.5499 28.9505C22.316 22.0462 23.3642 14.8299 26.6938 8.45266C29.1235 13.1047 30.3382 18.2049 30.3382 23.3048C30.3382 25.1942 30.1713 27.083 29.8378 28.9499C29.8112 29.099 29.9295 29.2003 30.05 29.2003C30.1173 29.2003 30.1845 29.1692 30.2282 29.0973C32.9875 24.5703 37.0569 20.8881 42.0055 18.6067C41.2292 22.9651 39.4114 26.9958 36.7824 30.4C35.6041 31.9251 34.2635 33.3251 32.7803 34.5719C32.62 34.7064 32.7292 34.9486 32.912 34.9486C32.9352 34.9486 32.9593 34.9444 32.9847 34.9365C35.1065 34.2222 37.3343 33.8559 39.5783 33.8559C41.544 33.8559 43.5223 34.1366 45.4535 34.7102C41.7505 37.6676 37.1952 39.2226 32.5704 39.2226L32.5706 39.2232Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div>
                  <svg
                    width="54"
                    height="59"
                    viewBox="0 0 54 59"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M53.1365 33.211L46.4851 31.2362C44.7856 30.7316 43.0405 30.4155 41.2777 30.2918C43.405 26.931 44.8757 23.1607 45.573 19.2428L46.7898 12.4116L40.4885 15.3163C38.0522 16.4393 35.7953 17.8617 33.7612 19.5455C33.2873 15.0978 31.9778 10.7432 29.9053 6.7751L26.6932 0.625L23.4811 6.77596C21.6483 10.2863 20.4189 14.0499 19.8271 17.9621C19.7474 18.4887 19.6797 19.0162 19.6236 19.5441C17.5898 17.8612 15.3341 16.4396 12.8983 15.3161L6.59701 12.4114L7.81387 19.2426C8.51161 23.1607 9.98231 26.9314 12.1091 30.2916C10.346 30.4149 8.60129 30.7318 6.90173 31.236L0.25 33.2108L5.67116 37.541C8.4148 39.7326 11.6082 41.2939 14.9914 42.1329C14.8435 42.4024 14.7044 42.6728 14.5769 42.9423L11.6131 49.2166L18.4555 48.0632C20.7635 47.6741 22.9759 46.7587 24.8856 45.4069L24.8852 58.375H28.5084V45.4122C30.4164 46.7612 32.6255 47.6748 34.9297 48.0628L41.7725 49.2162L38.8088 42.9419C38.6817 42.6724 38.5422 42.4016 38.3943 42.1324C41.7771 41.2935 44.9701 39.7323 47.7145 37.5406L53.1365 33.211ZM32.5706 39.2232C31.8766 39.2232 34.4441 42.1824 35.5343 44.4899C33.6022 44.1639 31.8109 43.3764 30.293 42.2277C29.052 41.2878 27.995 40.1071 27.193 38.7391C27.0921 38.5671 26.9077 38.4612 26.7088 38.4579H26.6988H26.6897C26.4874 38.4579 26.2988 38.5646 26.1963 38.7395C25.3939 40.1075 24.3373 41.2891 23.0963 42.2281C21.5784 43.3769 19.7875 44.1648 17.855 44.4903C18.9452 42.1824 21.5122 39.2237 20.8183 39.2237C16.1928 39.2237 11.638 37.6687 7.93413 34.7108C9.86495 34.1373 11.8436 33.8565 13.8093 33.8565C16.0532 33.8565 18.2807 34.2224 20.4025 34.9372C20.4275 34.9455 20.452 34.9492 20.4752 34.9492C20.658 34.9492 20.7672 34.7075 20.6069 34.5725C19.1238 33.3257 17.7831 31.9256 16.6048 30.4006C13.9766 26.9966 12.1584 22.9659 11.3817 18.6074C16.3307 20.8887 20.4 24.5714 23.159 29.098C23.2031 29.1694 23.2704 29.201 23.3376 29.201C23.4581 29.201 23.5769 29.0996 23.5499 28.9505C22.316 22.0462 23.3642 14.8299 26.6938 8.45266C29.1235 13.1047 30.3382 18.2049 30.3382 23.3048C30.3382 25.1942 30.1713 27.083 29.8378 28.9499C29.8112 29.099 29.9295 29.2003 30.05 29.2003C30.1173 29.2003 30.1845 29.1692 30.2282 29.0973C32.9875 24.5703 37.0569 20.8881 42.0055 18.6067C41.2292 22.9651 39.4114 26.9958 36.7824 30.4C35.6041 31.9251 34.2635 33.3251 32.7803 34.5719C32.62 34.7064 32.7292 34.9486 32.912 34.9486C32.9352 34.9486 32.9593 34.9444 32.9847 34.9365C35.1065 34.2222 37.3343 33.8559 39.5783 33.8559C41.544 33.8559 43.5223 34.1366 45.4535 34.7102C41.7505 37.6676 37.1952 39.2226 32.5704 39.2226L32.5706 39.2232Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div>
                  <svg
                    width="54"
                    height="59"
                    viewBox="0 0 54 59"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M53.1365 33.211L46.4851 31.2362C44.7856 30.7316 43.0405 30.4155 41.2777 30.2918C43.405 26.931 44.8757 23.1607 45.573 19.2428L46.7898 12.4116L40.4885 15.3163C38.0522 16.4393 35.7953 17.8617 33.7612 19.5455C33.2873 15.0978 31.9778 10.7432 29.9053 6.7751L26.6932 0.625L23.4811 6.77596C21.6483 10.2863 20.4189 14.0499 19.8271 17.9621C19.7474 18.4887 19.6797 19.0162 19.6236 19.5441C17.5898 17.8612 15.3341 16.4396 12.8983 15.3161L6.59701 12.4114L7.81387 19.2426C8.51161 23.1607 9.98231 26.9314 12.1091 30.2916C10.346 30.4149 8.60129 30.7318 6.90173 31.236L0.25 33.2108L5.67116 37.541C8.4148 39.7326 11.6082 41.2939 14.9914 42.1329C14.8435 42.4024 14.7044 42.6728 14.5769 42.9423L11.6131 49.2166L18.4555 48.0632C20.7635 47.6741 22.9759 46.7587 24.8856 45.4069L24.8852 58.375H28.5084V45.4122C30.4164 46.7612 32.6255 47.6748 34.9297 48.0628L41.7725 49.2162L38.8088 42.9419C38.6817 42.6724 38.5422 42.4016 38.3943 42.1324C41.7771 41.2935 44.9701 39.7323 47.7145 37.5406L53.1365 33.211ZM32.5706 39.2232C31.8766 39.2232 34.4441 42.1824 35.5343 44.4899C33.6022 44.1639 31.8109 43.3764 30.293 42.2277C29.052 41.2878 27.995 40.1071 27.193 38.7391C27.0921 38.5671 26.9077 38.4612 26.7088 38.4579H26.6988H26.6897C26.4874 38.4579 26.2988 38.5646 26.1963 38.7395C25.3939 40.1075 24.3373 41.2891 23.0963 42.2281C21.5784 43.3769 19.7875 44.1648 17.855 44.4903C18.9452 42.1824 21.5122 39.2237 20.8183 39.2237C16.1928 39.2237 11.638 37.6687 7.93413 34.7108C9.86495 34.1373 11.8436 33.8565 13.8093 33.8565C16.0532 33.8565 18.2807 34.2224 20.4025 34.9372C20.4275 34.9455 20.452 34.9492 20.4752 34.9492C20.658 34.9492 20.7672 34.7075 20.6069 34.5725C19.1238 33.3257 17.7831 31.9256 16.6048 30.4006C13.9766 26.9966 12.1584 22.9659 11.3817 18.6074C16.3307 20.8887 20.4 24.5714 23.159 29.098C23.2031 29.1694 23.2704 29.201 23.3376 29.201C23.4581 29.201 23.5769 29.0996 23.5499 28.9505C22.316 22.0462 23.3642 14.8299 26.6938 8.45266C29.1235 13.1047 30.3382 18.2049 30.3382 23.3048C30.3382 25.1942 30.1713 27.083 29.8378 28.9499C29.8112 29.099 29.9295 29.2003 30.05 29.2003C30.1173 29.2003 30.1845 29.1692 30.2282 29.0973C32.9875 24.5703 37.0569 20.8881 42.0055 18.6067C41.2292 22.9651 39.4114 26.9958 36.7824 30.4C35.6041 31.9251 34.2635 33.3251 32.7803 34.5719C32.62 34.7064 32.7292 34.9486 32.912 34.9486C32.9352 34.9486 32.9593 34.9444 32.9847 34.9365C35.1065 34.2222 37.3343 33.8559 39.5783 33.8559C41.544 33.8559 43.5223 34.1366 45.4535 34.7102C41.7505 37.6676 37.1952 39.2226 32.5704 39.2226L32.5706 39.2232Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div>
                  <svg
                    width="54"
                    height="59"
                    viewBox="0 0 54 59"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M53.1365 33.211L46.4851 31.2362C44.7856 30.7316 43.0405 30.4155 41.2777 30.2918C43.405 26.931 44.8757 23.1607 45.573 19.2428L46.7898 12.4116L40.4885 15.3163C38.0522 16.4393 35.7953 17.8617 33.7612 19.5455C33.2873 15.0978 31.9778 10.7432 29.9053 6.7751L26.6932 0.625L23.4811 6.77596C21.6483 10.2863 20.4189 14.0499 19.8271 17.9621C19.7474 18.4887 19.6797 19.0162 19.6236 19.5441C17.5898 17.8612 15.3341 16.4396 12.8983 15.3161L6.59701 12.4114L7.81387 19.2426C8.51161 23.1607 9.98231 26.9314 12.1091 30.2916C10.346 30.4149 8.60129 30.7318 6.90173 31.236L0.25 33.2108L5.67116 37.541C8.4148 39.7326 11.6082 41.2939 14.9914 42.1329C14.8435 42.4024 14.7044 42.6728 14.5769 42.9423L11.6131 49.2166L18.4555 48.0632C20.7635 47.6741 22.9759 46.7587 24.8856 45.4069L24.8852 58.375H28.5084V45.4122C30.4164 46.7612 32.6255 47.6748 34.9297 48.0628L41.7725 49.2162L38.8088 42.9419C38.6817 42.6724 38.5422 42.4016 38.3943 42.1324C41.7771 41.2935 44.9701 39.7323 47.7145 37.5406L53.1365 33.211ZM32.5706 39.2232C31.8766 39.2232 34.4441 42.1824 35.5343 44.4899C33.6022 44.1639 31.8109 43.3764 30.293 42.2277C29.052 41.2878 27.995 40.1071 27.193 38.7391C27.0921 38.5671 26.9077 38.4612 26.7088 38.4579H26.6988H26.6897C26.4874 38.4579 26.2988 38.5646 26.1963 38.7395C25.3939 40.1075 24.3373 41.2891 23.0963 42.2281C21.5784 43.3769 19.7875 44.1648 17.855 44.4903C18.9452 42.1824 21.5122 39.2237 20.8183 39.2237C16.1928 39.2237 11.638 37.6687 7.93413 34.7108C9.86495 34.1373 11.8436 33.8565 13.8093 33.8565C16.0532 33.8565 18.2807 34.2224 20.4025 34.9372C20.4275 34.9455 20.452 34.9492 20.4752 34.9492C20.658 34.9492 20.7672 34.7075 20.6069 34.5725C19.1238 33.3257 17.7831 31.9256 16.6048 30.4006C13.9766 26.9966 12.1584 22.9659 11.3817 18.6074C16.3307 20.8887 20.4 24.5714 23.159 29.098C23.2031 29.1694 23.2704 29.201 23.3376 29.201C23.4581 29.201 23.5769 29.0996 23.5499 28.9505C22.316 22.0462 23.3642 14.8299 26.6938 8.45266C29.1235 13.1047 30.3382 18.2049 30.3382 23.3048C30.3382 25.1942 30.1713 27.083 29.8378 28.9499C29.8112 29.099 29.9295 29.2003 30.05 29.2003C30.1173 29.2003 30.1845 29.1692 30.2282 29.0973C32.9875 24.5703 37.0569 20.8881 42.0055 18.6067C41.2292 22.9651 39.4114 26.9958 36.7824 30.4C35.6041 31.9251 34.2635 33.3251 32.7803 34.5719C32.62 34.7064 32.7292 34.9486 32.912 34.9486C32.9352 34.9486 32.9593 34.9444 32.9847 34.9365C35.1065 34.2222 37.3343 33.8559 39.5783 33.8559C41.544 33.8559 43.5223 34.1366 45.4535 34.7102C41.7505 37.6676 37.1952 39.2226 32.5704 39.2226L32.5706 39.2232Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
              <p>
                {t("A maximum of 40 DECT tokens can be purchased per person.")}
              </p>
            </div>
          </div>
          <div className={styles.packages__second_right}>
            <div className={styles.table}>
              <div className={styles.table__head}>
                <div>{t("Time of the DECT purchase")}</div>
                <div>{t("Annual harvest yields")}</div>
                {/* <div>{t("Corresponds to")}</div> */}
              </div>
              <div className={styles.table__head_mobile}>
                <div>{t("Time of the DECT purchase ")}</div>
                <div>{t("Annual harvest yields")}</div>
                {/* <div>{t("Corresponds to")}</div> */}
              </div>
              <div className={styles.table__body}>
                <div className={styles.table__row}>
                  <div className={styles.table__month}>
                    <div className={styles.table__row_month}>
                      {t("Until May 2024")}{" "}
                    </div>
                    {/* <div className={styles.table__row_month}>
                      {t("August,")}{" "}
                    </div>
                    <div className={styles.table__row_month}>
                      {t("September")}{" "}
                    </div> */}
                  </div>
                  <div>{t("80% = 200g Cannabis")}</div>
                  {/* <div>{t("20 percent")}</div> */}
                </div>
                <div className={styles.table__row}>
                  <div className={styles.table__month}>
                    <div className={styles.table__row_month}>{t("June")}</div>
                    <div className={styles.table__row_month}>{t("and")}</div>
                    <div className={styles.table__row_month}>{t("July")} </div>
                  </div>
                  <div>{t("60% = 150g Cannabis")}</div>
                  {/* <div>{t("15 percent")}</div> */}
                </div>
                <div className={styles.table__row}>
                  <div>{t("From August")}</div>
                  <div>{t("40% = 100g Cannabis")}</div>
                  {/* <div>{t("10 percent")}</div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <p className={styles.packages__adds}>
          {t(
            "The earlier a plant is purchased, the higher the return of the plant spot NFT."
          )}
        </p>
      </div>
    </section>
  );
};

export default Packages;
